<h2>WAIT!</h2>

@switch (data.Type) {
  @case (changeType.IncomingFloorplanConflict) {
    <p>
      The {{theme.fpLabel}} you are trying to select is in a <b>different {{theme.neighborhoodLabel.toLowerCase()}}</b> than your current
      {{theme.lotLabel}}. How would you like to continue?
    </p>
  }
  @case (changeType.IncomingLotConflict) {
    <p>
      The {{theme.lotLabel}} you are trying to select is in a <b>different {{theme.neighborhoodLabel.toLowerCase()}}</b> than your current
      {{theme.fpLabel}}. How would you like to continue?
    </p>
  }
  @case (changeType.ClearSessionData) {
    <P>
    You are about to remove all of your selections and this action cannot be undone. You will be redirected back to the start.
    Are you sure you want to remove all of your selections?
  </P>
}
}

<div class="flex row align-center justify-center allow-wrap">
  @switch (data.Type) {
    @case (changeType.IncomingFloorplanConflict) {
      <button class="hc-btn secondary" (click)="handleProceed()">Unselect {{theme.lotLabel}}
        &amp;
      select {{theme.fpLabel}}</button>
    }
    @case (changeType.IncomingLotConflict) {
      <button class="hc-btn secondary" (click)="handleProceed()">Unselect {{theme.fpLabel}} &amp;
        select
      {{theme.lotLabel}}</button>
    }
    @case (changeType.ClearSessionData) {
      <button class="hc-btn secondary" (click)="handleProceed()">
        Remove All Selections
      </button>
    }
  }

  @if (!changeType.ClearSessionData) {
    <button class="hc-btn negative" (click)="handleCancel()">Cancel selection</button>
  }
  @if (changeType.ClearSessionData) {
    <button class="hc-btn negative" (click)="handleCancel()">Cancel</button>
  }
</div>